// src/components/layout/ImpersonationBanner.js

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../hooks/useAuth";
import { getImpersonator, endImpersonation } from "../../utils/impersonation";
import "../../scss/demo.scss";

/**
 * Shown to admins who entered this account via the Hub admin panel's "Login as user..." action.
 * Renders nothing in a normal session. Modeled on DemoBanner.js's placement/styling (see
 * utils/impersonation.js for the backend handover this drives off).
 */
function ImpersonationBanner() {
  const { t } = useTranslation();
  const { auth } = useAuth();
  const impersonator = getImpersonator();
  const [leaving, setLeaving] = useState(false);

  if (!impersonator) return null;

  return (
    <div className="demo-banner impersonation-banner">
      <div className="demo-banner-left">
        <span className="demo-banner-badge">{t("impersonation.badge")}</span>
        <span>{t("impersonation.bannerMessage", { user: auth?.user?.email, impersonator })}</span>
      </div>
      <button
        className="demo-banner-exit"
        disabled={leaving}
        onClick={() => {
          setLeaving(true);
          endImpersonation();
        }}
      >
        {leaving ? t("impersonation.leaving") : t("impersonation.exit")}
      </button>
    </div>
  );
}

export default ImpersonationBanner;
